// SPDX-License-Identifier: MPL-2.0

import { ja } from './ja'

export const ko: Record<keyof typeof ja, string> = {
  // App
  'app.title': '가구야',
  'app.tagline': '가구야 — 다정한 Misskey 클라이언트',
  'app.subtitle': '다정하고 심플한 Misskey 클라이언트',

  // Navigation
  'nav.home': '홈',
  'nav.inbox': '수신함',
  'nav.notifications': '알림',
  'nav.settings': '설정',
  'nav.back': '뒤로',
  'nav.side_navigation': '사이드 내비게이션',
  'nav.bottom_navigation': '하단 내비게이션',

  // Common actions
  'action.close': '닫기',
  'action.cancel': '취소',
  'action.remove': '삭제',
  'action.back': '뒤로',
  'action.copy': '복사',
  'action.retry': '다시 시도',
  'action.refresh': '새로고침',
  'action.refresh_cooldown': '{s}초 후에 새로고침할 수 있어요',
  'action.load_more': '더 불러오기',

  // Theme
  'theme.switch_to_light': '라이트 모드로 전환',
  'theme.switch_to_dark': '다크 모드로 전환',
  'theme.system': '시스템',
  'theme.light': '라이트',
  'theme.dark': '다크',

  // Quiet mode
  'quiet_mode.on': '휴식 모드',
  'quiet_mode.off': '휴식 모드 해제',
  'quiet_mode.status': '휴식 중',
  'quiet_mode.manual_active': '휴식 모드 중 — 스트리밍을 잠시 멈추고 있어요',
  'quiet_mode.hours_active': '휴식 시간이에요',
  'quiet_mode.resume': '다시 시작',

  // Compose
  'compose.title': '노트 쓰기',
  'compose.placeholder': '지금 무슨 생각을 하고 있나요?',
  'compose.cw_placeholder': '열람 주의(CW) 주석',
  'compose.cw_button': '열람 주의 (CW)',
  'compose.attach_image': '이미지 첨부',
  'compose.attachment_alt': '첨부 이미지',
  'compose.alt_placeholder': '그림 설명(보지 못하는 사람을 위해). hackers.pub에서는 비워두면 자동으로 써 드려요',
  'compose.alt_required': '그림 설명을 만들지 못했어요. 적고 나서 다시 보내 주세요',
  'compose.visibility': '공개 범위',
  'compose.language': '언어',
  'compose.language_auto': '자동 ({lang})',
  'compose.visibility_public': '공개',
  'compose.visibility_home': '홈에만',
  'compose.visibility_followers': '팔로워 한정',
  'compose.visibility_specified': '다이렉트',

  // Timeline
  'timeline.filtered': '필터',
  'timeline.filtered_active': '필터 적용 중',
  'compose.sending': '보내는 중...',
  'compose.submit': '노트',
  'compose.posted': '게시했어요',
  'compose.reply_placeholder': '답글 쓰기...',

  // Note
  'note.collapse_cw': '접기',
  'note.reveal_cw': '보기',
  'note.reply': '답글',
  'note.renote': '리노트',
  'note.reaction': '리액션',
  'note.add_reaction': '리액션 추가',
  'note.more': '더 보기',
  'note.open_original': '원본 열기',
  'note.copy_link': '링크 복사',
  'note.link_copied': '링크를 복사했어요',
  'note.copy_failed': '복사하지 못했어요',
  'note.from_user': '님의 노트',
  'note.user_renoted': '님이 리노트',
  'note.section_replies': '답글',

  // Note errors
  'note.renoted': '리노트했어요',
  'note.renote_failed': '리노트하지 못했어요',
  'note.reaction_failed': '리액션하지 못했어요',
  'note.post_failed': '게시하지 못했어요',
  'note.image_upload_failed': '이미지 업로드에 실패했어요',
  'note.favorite': '즐겨찾기',
  'note.unfavorite': '즐겨찾기 해제',
  'note.favorited': '즐겨찾기에 추가했어요',
  'note.unfavorited': '즐겨찾기에서 삭제했어요',
  'note.favorite_failed': '즐겨찾기에 추가하지 못했어요',

  // Image
  'image.sensitive_aria': '열람 주의 이미지, 탭하면 표시',
  'image.enlarge': '이미지 확대',
  'image.show_sensitive': '열람 주의 콘텐츠 표시',
  'image.sensitive_label': '열람 주의',
  'image.tap_to_show': '탭해서 보기',
  'image.show_more_files': '더 보기 ({n}개)',
  'image.viewer': '이미지 뷰어',
  'image.close_viewer': '이미지 뷰어 닫기',

  // Timeline
  'timeline.home': '홈',
  'timeline.local': '로컬',
  'timeline.global': '글로벌',
  'timeline.hybrid': '소셜',
  'timeline.antenna': '안테나',
  'timeline.list': '리스트',
  'timeline.channel': '채널',
  'timeline.feed': '피드',
  'timeline.streaming': '실시간',
  'timeline.loading': '불러오는 중...',
  'timeline.no_notes': '아직 노트가 없어요',
  'timeline.filter_no_rules': '이 타임라인은 리액션 수로 로컬 노트를 추려서 보여줘요.',
  'timeline.filter_no_rules_hint': '설정 → 필터 타임라인에서 규칙을 추가해 주세요.',
  'timeline.filter_hides_all': '지금은 필터 조건에 맞는 노트가 없어요.',
  'timeline.user_filter_hides_all': '가져온 노트가 모두 사용자 필터로 숨겨져 있어요.',
  'timeline.no_more': '더 이상 없어요',
  'timeline.load_failed': '불러오지 못했어요',
  'timeline.reconnecting': '연결을 기다리고 있어요…',
  'timeline.load_failed_retry': '불러오지 못했어요. 다시 시도해 주세요',
  'timeline.caught_up': '여기까지 읽었어요',
  'timeline.new_notes': '개의 새 노트',
  'timeline.show_new': '표시하기',
  'timeline.details': '자세히',
  'timeline.what_went_wrong': '무슨 일이 있었는지 자세히 보기',

  // Notifications
  'notifications.title': '알림',
  'notifications.empty': '아직 알림이 없어요',
  'notifications.close': '알림 닫기',
  'notifications.mark_all_read': '모두 읽음으로 표시',

  // Emoji
  'emoji.picker': '이모지 선택기',
  'emoji.search_placeholder': '이모지 검색...',
  'emoji.search': '이모지 검색',
  'emoji.close_picker': '이모지 선택기 닫기',
  'emoji.all': '전체',
  'emoji.not_found': '이모지를 찾을 수 없어요',
  'emoji.list': '이모지 목록',
  'emoji.select': ' 선택',

  // Account
  'account.menu': '계정 메뉴',
  'account.remove': '계정 삭제',
  'account.add': '계정 추가',
  'account.logout': '로그아웃',
  'account.invalid_tokens': '토큰이 유효하지 않은 계정',

  // Settings
  'settings.title': '설정',
  'settings.section_account': '계정',
  'settings.section_notifications': '알림',
  'settings.push_notifications': '푸시 알림',
  'settings.section_posting': '게시',
  'settings.section_filtered_timeline': '필터 타임라인',
  'settings.filtered_timeline_description': '「필터」 로컬 타임라인은 아래 규칙에 모두 일치하는 노트만 보여줘요. 리액션 이름은 부분 일치예요(예: 「kawaii」는 :kawaii@.: 에 일치).',
  'settings.filter_logic': '규칙 결합',
  'settings.filter_emoji': '리액션 이름',
  'settings.filter_emoji_placeholder': '예: kawaii',
  'settings.filter_operator': '연산자',
  'settings.filter_threshold': '개수',
  'settings.filter_add_rule': '규칙 추가',
  'settings.filter_no_rules': '규칙 없음 — 로컬의 모든 노트가 표시돼요.',
  'settings.default_note_visibility': '노트 기본 공개 범위',
  'settings.default_renote_visibility': '리노트 기본 공개 범위',
  'settings.section_display': '표시',
  'settings.font_size': '글자 크기',
  'settings.font_small': '작게',
  'settings.font_medium': '보통',
  'settings.font_large': '크게',
  'settings.reduce_motion': '애니메이션 줄이기',
  'settings.streaming': '라이브 스트리밍',
  'settings.streaming_description': '새 노트가 도착할 때마다 타임라인을 자동으로 갱신해요. 차분한 경험을 위해 처음에는 꺼져 있어요.',
  'settings.section_quiet': '휴식 모드',
  'settings.quiet_manual': '지금 휴식 모드 켜기',
  'settings.quiet_manual_description': '스트리밍을 멈추고, 라이브 표시를 차분하게 하고, 새 노트를 잠시 보류해요.',
  'settings.quiet_hours': '휴식 시간',
  'settings.quiet_hours_description': '지정한 시간대에는 자동으로 휴식 모드가 켜져요.',
  'settings.quiet_hours_range': '시간대',
  'settings.quiet_hours_start': '시작 시각',
  'settings.quiet_hours_end': '종료 시각',
  'settings.media_proxy': '미디어 프록시(프라이버시 보호)',
  'settings.media_proxy_description': '이미지와 이모지를 인스턴스 프록시를 통해 불러와 IP 주소 노출을 막아요.',
  'settings.hide_nsfw': 'NSFW 콘텐츠 숨기기',
  'settings.hide_nsfw_description': '열람 주의(CW)나 민감한 이미지가 포함된 노트를 타임라인에서 숨겨요.',
  'settings.section_theme': '테마',
  'settings.section_language': '언어',
  'settings.section_cache': '캐시',
  'settings.cache_emoji': '이모지 캐시',
  'settings.cache_emoji_description': '인스턴스의 커스텀 이모지를 모두 내려받아 캐시해요. 보통 이모지는 표시할 때 불러와요.',
  'settings.cache_emoji_btn': '이모지 캐시하기',
  'settings.cache_emoji_loading': '캐시하는 중...',
  'settings.cache_emoji_done': '캐시 완료',
  'settings.section_data': '데이터',
  'settings.clear_all_data': '모든 데이터 삭제',
  'settings.clear_all_confirm': '모든 데이터를 삭제할까요?\n계정 정보와 설정이 모두 지워져요. 이 작업은 되돌릴 수 없어요.',
  'settings.reset_app': '캐시 삭제',
  'settings.reset_app_description': '뭔가 잘 안 될 때 사용해요. 오래된 Service Worker와 캐시를 지우고 다시 불러와요. JavaScript가 깨져 있어도 동작해요.',
  'settings.section_about': '이 앱에 대해',
  'settings.about_privacy': '이 앱은 애널리틱스나 트래킹을 전혀 사용하지 않아요. 계정 정보와 설정은 모두 이 브라우저의 localStorage에만 저장되며, 외부 서버로 전송되지 않아요.',

  // Login
  'login.instance': '인스턴스',
  'login.instance_placeholder': 'misskey.io',
  'login.access_token': '액세스 토큰',
  'login.permission_mode': '권한 모드',
  'login.permission_standard': '표준(읽기/쓰기)',
  'login.permission_readonly': '읽기 전용',
  'login.permission_details_summary': '권한에 대해 자세히',
  'login.permission_standard_detail': '표준(읽기/쓰기): 노트 게시, 리액션, 팔로우 등 모든 작업을 할 수 있어요.',
  'login.permission_readonly_detail': '읽기 전용: 타임라인 보기만 가능해요. 실수로 조작할 걱정이 없어요.',
  'login.token_privacy': '토큰은 이 브라우저에만 저장되며 외부로 전송되지 않아요.',
  'login.connecting': '연결하는 중...',
  'login.login_with_token': '토큰으로 연결',
  'login.login_with_miauth': 'MiAuth로 로그인',
  'login.login_with_oauth2': 'OAuth2로 로그인',
  'login.help_miauth': '인스턴스로 이동해서 인증해요. 토큰을 직접 만들 필요가 없어요.',
  'login.help_token': '인스턴스의 설정 → API에서 액세스 토큰을 발급받아 주세요.',
  'login.help_oauth2': 'OAuth2로 안전하게 인증해요. 인스턴스가 OAuth2를 지원하지 않으면 MiAuth를 시도해 보세요.',
  'login.help_mastodon': 'OAuth2로 안전하게 인증해요.',
  'login.help_hackerspub': 'hackers.pub은 메일로 로그인해요. 사용자 이름(또는 메일)을 입력하고, 받은 코드를 입력해 주세요.',
  'login.hp_username': '사용자 이름',
  'login.hp_email': '메일 주소',
  'login.hp_use_username': '사용자 이름',
  'login.hp_use_email': '메일',
  'login.hp_send_code': '코드 보내기',
  'login.hp_code': '로그인 코드',
  'login.hp_code_sent': '로그인 코드를 메일로 보냈어요. 여기에 입력해 주세요.',
  'login.hp_verify': '확인',
  'login.hp_back': '다른 계정으로 하기',
  'login.hp_link_sent': '메일을 보냈어요. 받은 링크를 누르면 로그인할 수 있어요.',
  'login.hp_enter_code': '코드 입력하기',
  'login.login_with_bluesky': 'Bluesky로 로그인',
  'login.help_bluesky': 'Bluesky 핸들을 입력해 주세요. 인증 페이지로 이동해요.',
  'login.bluesky_handle': 'Bluesky 핸들',
  'login.validating': '불러오는 중...',

  // Auth errors
  'error.invalid_credentials': '로그인하지 못했어요. 인스턴스 URL과 토큰을 확인해 주세요.',
  'error.network': '서버에 연결하지 못했어요. 인스턴스 URL과 네트워크 환경을 확인해 주세요.',
  'error.unknown': '잘 되지 않았어요. 잠시 후에 다시 시도해 주세요.',
  'error.not_connected': '서버에 연결되어 있지 않은 것 같아요',
  'readonly.explanation': '읽기 전용 토큰으로 연결 중이라 게시·리액션·팔로우는 할 수 없어요.',
  'error.post_failed': '게시하지 못했어요',

  // Auth callback
  'auth.checking': '인증 확인 중...',
  'auth.login_success': '로그인 성공!',
  'auth.redirecting_home': '홈으로 이동하는 중...',
  'auth.failed': '인증에 실패했어요.',
  'auth.error_details': '오류 상세',
  'auth.back_to_login': '로그인 페이지로 돌아가기',
  'auth.hp_other_browser': '이 링크는 로그인을 시작한 브라우저와 다른 브라우저에서 열린 것 같아요.',
  'auth.hp_sign_in_here': '이 브라우저에서 로그인',
  'auth.hp_copy_code': '코드 복사',
  'auth.hp_copied': '복사했어요',
  'auth.hp_copy_hint': '복사한 코드를, 로그인을 시작한 브라우저의 「코드 입력하기」에 붙여넣어 주세요.',
  'auth.logging_in': '로그인하는 중...',
  'auth.session_expired': '세션이 만료되었거나 찾을 수 없어요.',
  'auth.redirecting_login': '로그인 페이지로 이동하는 중...',

  // User page
  'user.decode_failed': '사용자 정보를 해석하지 못했어요',
  'user.stat_notes': '노트',
  'user.stat_following': '팔로잉',
  'user.stat_followers': '팔로워',
  'user.pinned_notes': '고정됨',
  'user.section_notes': '노트',
  'user.no_notes': '아직 노트가 없어요',
  'user.no_more': '더 이상 없어요',
  'user.follow': '팔로우',
  'user.unfollow': '팔로우 해제',
  'user.follow_failed': '팔로우하지 못했어요',
  'user.unfollow_failed': '팔로우를 해제하지 못했어요',
  'user.followed': '팔로우했어요',
  'user.unfollowed': '팔로우를 해제했어요',
  'user.bot_badge': 'Bot',

  // Poll
  'poll.votes': '표',
  'poll.expired': '투표 종료',
  'poll.expires_at': '마감',
  'poll.vote_failed': '투표하지 못했어요',
  'poll.voted': '투표했어요',
  'poll.label': '투표',

  // Note page
  'note_page.remote_fetch_failed': '리모트 노트를 가져오지 못했어요',
  'note_page.remote_resolve_failed': '리모트 URI를 노트로 해석하지 못했어요',
  'note_page.decode_failed': '노트를 해석하지 못했어요',
  'note_page.remote_warning': '이 노트는 연합된 서버에서 가져온 사본이에요. 원본 노트보다 정보가 불완전할 수 있어요.',
  'note_page.view_original': '원본 노트 보기 →',

  // Push notifications
  'push.unsupported': '푸시 알림 미지원',
  'push.permission_denied': '알림이 거부되어 있어요',
  'push.generating': '스크립트 생성 중...',
  'push.disable': '푸시 알림 끄기',
  'push.reload_retry': '페이지를 새로고침하고 다시 시도',
  'push.enable': '푸시 알림 켜기',
  'push.script_instructions': '아래 AiScript를 Misskey의 스크래치패드에서 실행해 주세요:',
  'push.open_scratchpad': '스크래치패드 열기',
  'push.executed': '실행했어요',
  'push.migrated': '푸시 알림은 네이티브 Misskey 방식으로 바뀌었어요. 설정에서 켜 주세요.',
  'push.back_to_settings': '← 설정으로',

  // App state
  'app.new_version': '새 버전을 사용할 수 있어요',
  'app.update_now': '지금 업데이트',
  'app.select_note': '노트를 선택해 주세요',
  'app.loading': '불러오는 중...',

  // Image gallery
  'image.gallery_single': '이미지',
  'image.gallery_count': '장의 이미지',

  // MFM
  'mfm.search_button': '검색',

  // User filter
  'user_filter.button': '사용자 필터',
  'user_filter.images_only': '이미지만 표시',
  'user_filter.no_renotes': '리노트 숨기기',

  // Inbox
  'inbox.title': '수신함',
  'inbox.empty': '수신함이 비어 있어요',
  'inbox.clear_all': '모두 지우기',
  'inbox.dismiss_group': '지우기',
  'inbox.see_all': '모든 알림 보기',
  'inbox.group_direct': '멘션·답글',
  'inbox.group_quotes': '인용',
  'inbox.group_renotes': '리노트',
  'inbox.group_reactions': '리액션',
  'inbox.group_follows': '팔로우',
  'inbox.group_other': '기타',
  'inbox.group_home': '홈 타임라인',
  'inbox.go_home': '홈으로',
  'inbox.view_thread': '스레드 보기',
  'inbox.mark_read': '읽음으로 표시',

  // Timeline Inbox
  'timeline_inbox.title': '타임라인 수신함',

  // Interpolated
  'aria.mention_to': '멘션: {handle}',
  'aria.emoji_name': '{name} 이모지',

  // Generic
  'generic.error_prefix': '오류',
}
